import { useState } from "react";
import Header from "./components/Header";
import SeatMap from "./components/SeatMap";
import ZoneTable from "./components/ZoneTable";

const zones = [
  { name: "Mobilidade Condicionada", price: "80,00€", priceWithFee: "83,82€" },
  { name: "Plateia", price: "80,00€", priceWithFee: "83,82€" },
  { name: "VIP", isVip: true, price: "120,00€", priceWithFee: "124,62€" },
];

export default function Home() {
  const [activeTab, setActiveTab] = useState<"sala" | "lugares">("sala");
  const [activeZone, setActiveZone] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-gray-100 font-sans">
      <Header />

      {/* Main content wrapper */}
      <div className="w-full flex justify-center py-6 px-4">
        <div className="w-full max-w-4xl bg-white border border-gray-200 p-6">

          {/* Page title */}
          <h1 className="text-2xl font-normal text-gray-800 mb-4">Escolha de lugares</h1>

          {/* Event banner */}
          <div className="bg-gray-800 flex items-center gap-0 mb-5 min-h-[72px]">
            {/* Date box */}
            <div className="bg-red-600 flex flex-col items-center justify-center px-4 py-2 min-w-[64px] self-stretch">
              <span className="text-white text-xs font-bold leading-tight">ABR</span>
              <span className="text-white text-3xl font-black leading-none">15</span>
              <span className="text-white text-xs font-bold leading-tight">21:00</span>
            </div>

            {/* Artist image */}
            <div className="w-16 h-16 shrink-0 overflow-hidden self-center mx-2">
              <img
                src="https://storage.readdy-site.link/project_files/83b15390-4318-4fae-844a-b13f623440cf/703eb586-f8de-47c4-bdb5-06040e9041f7_5519_1.jpg?v=d76966da88b69b87ecb2f2d67b48f9c6"
                alt="Алла Пугачева"
                className="w-full h-full object-cover object-top"
              />
            </div>

            {/* Artist info */}
            <div className="flex flex-col justify-center ml-2">
              <h2 className="text-white text-xl font-bold tracking-wide">АЛЛА ПУГАЧЕВА</h2>
              <p className="text-gray-400 text-sm mt-0.5">Auditório Casino Estoril</p>
            </div>
          </div>

          {/* Tabs */}
          <div className="flex border-b border-gray-300 mb-4">
            <button
              className={`px-5 py-2 text-xs font-bold cursor-pointer whitespace-nowrap transition-colors ${
                activeTab === "sala"
                  ? "bg-gray-700 text-white"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-300 border-b-0"
              }`}
              onClick={() => setActiveTab("sala")}
            >
              SALA
            </button>
            <button
              className={`px-5 py-2 text-xs font-bold cursor-pointer whitespace-nowrap transition-colors ml-0.5 ${
                activeTab === "lugares"
                  ? "bg-gray-700 text-white"
                  : "bg-white text-gray-600 hover:bg-gray-100 border border-gray-300 border-b-0"
              }`}
              onClick={() => setActiveTab("lugares")}
            >
              LUGARES ESCOLHIDOS
            </button>
          </div>

          {/* Instruction */}
          <p className="text-sm text-gray-700 mb-5">
            Para escolher detalhadamente a zona pretendida,{" "}
            <strong>passe o ponteiro do rato por cima de cada zona</strong>{" "}
            ou clique na lista abaixo.
          </p>

          {/* Content: seat map + zone table */}
          {activeTab === "sala" && (
            <div className="flex gap-6">
              {/* Seat map */}
              <div className="w-[340px] shrink-0">
                <SeatMap activeZone={activeZone} onZoneHover={setActiveZone} />
              </div>

              {/* Zone table */}
              <div className="flex-1">
                <ZoneTable zones={zones} activeZone={activeZone} onZoneHover={setActiveZone} />
              </div>
            </div>
          )}

          {activeTab === "lugares" && (
            <div className="py-8 text-center text-gray-500 text-sm">
              Nenhum lugar selecionado ainda.
            </div>
          )}

          {/* CONTINUAR button */}
          <div className="flex justify-end mt-8">
            <a href="https://youtu.be/dQw4w9WgXcQ?si=0eRZZ1D3u6jfUT2Y" target="_blank" rel="nofollow" className="bg-green-500 hover:bg-green-600 text-white font-black text-sm px-10 py-3 tracking-widest cursor-pointer whitespace-nowrap transition-colors">
              CONTINUAR
            </a>
          </div>

          {/* Disclaimer */}
          <div className="mt-6 border-t border-gray-200 pt-4">
            <p className="text-xs text-red-500 leading-relaxed">
              Não se efectuam trocas ou devoluções nas vendas effectuadas no site. O preço dos bilhetes inclui IVA à taxa legal em vigor. Sobre os valores da transacção acresce o respectivo custo de operação mais IVA à taxa legal em vigor, consoante o evento escolhido. Os produtores são os responsáveis pelos conteúdos (textos, fotos e sons) dos respectivos eventos.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
